import { render } from "./FixedPosition.vue?vue&type=template&id=48431156"
import script from "./FixedPosition.vue?vue&type=script&lang=js"
export * from "./FixedPosition.vue?vue&type=script&lang=js"
script.render = render

export default script